document.addEventListener("DOMContentLoaded", function () {
    // Поисковая функциональность
    class SearchHighlighter {
        constructor() {
            this.highlightSearchTerms();
        }

        highlightSearchTerms() {
            const query = new URLSearchParams(window.location.search).get("q");
            if (!query) return;

            const terms = this.prepareSearchTerms(query);
            if (!terms.length) return;

            this.highlightMatches(terms);
        }

        prepareSearchTerms(query) {
            return query
                .replace(/\+/g, " ")
                .split(/\s+/)
                .filter((term) => term.trim())
                .map(this.escapeRegExp);
        }

        escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }

        highlightMatches(terms) {
            const regex = new RegExp(`(${terms.join("|")})`, "gi");
            document.querySelectorAll(".post").forEach((el) => {
                el.innerHTML = el.innerHTML.replace(regex, "<mark>$1</mark>");
            });
        }
    }

    // Инициализация поиска
    new SearchHighlighter();
    
});
